import React from "react"
import "./facts-and-figures.scss"
import Svg from "../_svgs/svg"

export default function FactsAndFiguresGifContainer(props) {
  console.log(props)

  const leftGifs = props.gifContentArea.filter((item) => item.positionLeft) || []
  const rightGifs = props.gifContentArea.filter((item) => item.positionRight) || []

  return (
    <div className="fact-and-figures c--white">
      <div className="fact-and-figures-top w--narrow">
        <div className="fact-and-figures-top-content">
          <div className="arrowright">
            <Svg iconName={"arrowright"} fillColor={"#F8CA15"} />
          </div>
          <h1>{props.header}</h1>
          <p>{props.subHeader}</p>
          <div className="arrowdown">
            <Svg iconName={"arrow_ff_down"} fillColor={"#071143"} />
          </div>
        </div>
      </div>
      <div className="fact-and-figures-content">
        <div className="left-side">
          {leftGifs.map((gif) => {
            return <img src={gif.gifContentArea} key={gif.gifContentArea}></img>
          })}
          {/* 
                    <img src="imgs/secondarywater.gif" style="float:left; padding-top:40%;" />
                    */}
        </div>
        <div className="right-side">
          {rightGifs.map((gif) => {
            return <img src={gif.gifContentArea} key={gif.gifContentArea}></img>
          })}
        </div>
      </div>
    </div>
  )
}
